import { Col, Typography } from "@commonlibs";
import clsx from "clsx";

export interface AreaChartCardHeaderProps {
    className?: string;
    style?: React.CSSProperties;
    title: string;
}

function AreaChartCardHeader({ className, title, ...rest }: AreaChartCardHeaderProps) {
    return (
        <Col className={clsx("area-chart-card-header", className)} {...rest}>
            <Typography variant="body1Strong">{title}</Typography>
        </Col>
    );
}

export default AreaChartCardHeader;
